import { Injectable } from '@angular/core';
import { LoggerService } from '@klickdata/core/application';
import { AuthService } from '@klickdata/core/auth';
import { ResponseData } from '@klickdata/core/http';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { User, UserData } from './user.model';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root',
})
export class UserSocketService {
    constructor(
        protected userService: UserService,
        protected auth: AuthService,
        private readonly logger: LoggerService
    ) {}

    public listenToUserChannel(userId: number, event: string): Observable<User> {
        return this.auth.listenPrivate(`App.User.${userId}`, event).pipe(
            tap((payload) => this.logger.log(`${event} for user ${userId}`, payload)),
            filter((res: ResponseData<UserData>) => !!res?.data?.id),
            map((res: ResponseData<UserData>) => this.userService.mapUser(res.data))
        );
    }

    public listenToUserUpdateByCustomer(customerId: number): Observable<User> {
        return this.auth.listenPrivate(`customer.${customerId}`, 'UserCreatedOrUpdated').pipe(
            tap((payload) => this.logger.log(`UserCreatedOrUpdated for customer ${customerId}`, payload)),
            filter((res: ResponseData<UserData>) => !!res?.data?.id),
            map((res: ResponseData<UserData>) => this.userService.mapUser(res.data))
        );
    }

    public listenToMasterUserCreatedOrUpdated(): Observable<User> {
        return this.auth.listenUserChannel<ResponseData<UserData>>('MAUserCreatedOrUpdated').pipe(
            tap((payload: ResponseData<UserData>) => this.logger.log('MAUserCreatedOrUpdated', payload)),
            filter((res: ResponseData<UserData>) => !!res?.data?.id && !!res.data),
            map((res: ResponseData<UserData>) => this.userService.mapUser(res.data!))
        );
    }
}
